import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { SIZE_09 } from '@sama/design-tokens';
import { InjectableSuperclass } from '@sama/ng-core';
import { from } from 'rxjs';
import { Output } from '../../../team-apis/otterdam/outputs/output';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { OutputTabComponent } from '../output-tab/output-tab.component';

@Component({
  selector: 'h3-output-tabs',
  imports: [OutputTabComponent, MatIcon, MatRipple, AsyncPipe],
  templateUrl: './output-tabs.component.html',
  styleUrl: './output-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutputTabsComponent
  extends InjectableSuperclass
  implements OnInit, OnDestroy
{
  @ViewChild('tabsContainer', { static: true })
  tabsContainer!: ElementRef<HTMLDivElement>;
  @Input({ required: true }) outputs!: Output[];
  @Input() visibleOutputName: string | undefined;
  @HostBinding('class.with-arrows') shouldShowArrows!: boolean;

  scrollingDisabled = signal(false);
  leftScrollingDisabled = signal(true);
  rightScrollingDisabled = signal(false);
  selectedOutputName$ = inject(TaskWorkspaceStore)('selectedOutputName').$;

  private resizeObserver = new ResizeObserver(() =>
    this.updateScrollingDisabled(),
  );

  scrollLeft() {
    this.tabsContainer.nativeElement.scrollBy({
      left: -SIZE_09.replace('px', ''),
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.tabsContainer.nativeElement.scrollBy({
      left: +SIZE_09.replace('px', ''),
      behavior: 'smooth',
    });
  }

  ngOnInit() {
    this.resizeObserver.observe(this.tabsContainer.nativeElement);
    this.subscribeTo(from(document.fonts.ready), () =>
      this.updateScrollingDisabled(),
    );
    this.shouldShowArrows = this.outputs.length > 1;
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }

  updateLeftOrRightScrollingDisabled() {
    this.leftScrollingDisabled.set(
      this.tabsContainer.nativeElement.scrollLeft === 0,
    );
    this.rightScrollingDisabled.set(
      this.tabsContainer.nativeElement.scrollLeft +
        this.tabsContainer.nativeElement.clientWidth >=
        this.tabsContainer.nativeElement.scrollWidth,
    );
  }

  private updateScrollingDisabled() {
    this.scrollingDisabled.set(
      this.tabsContainer.nativeElement.scrollWidth ===
        this.tabsContainer.nativeElement.clientWidth,
    );
  }
}
